
























// vue
import { defineComponent, ref, watch, onBeforeMount } from '@vue/composition-api';

// primevue
import RadioButton from 'primevue/radiobutton';

export default defineComponent({
    props: {
        value: {
            type: Object,
            default: () => { return { value: '', operator: '==' } },
        },
    },
    components: { RadioButton },
    setup(props: any, { emit }) {
        const localValue = ref<boolean | null>(props.value.value);

        watch(localValue, (newVal) => {
            emit('input', { ...props.value, value: newVal, displayValue: newVal ? 'yes' : 'no' });
        });

        const onInput = (data: boolean) => {
            emit('input', { ...props.value, value: data, displayValue: data ? 'yes' : 'no' });
        };

        const onLoad = () => {
            emit('input', {...props.value, operator: '=='})
        }

        onBeforeMount(()=>{
            onLoad();
        })

        return {
            localValue,
            onInput,
        };
    },
});
